import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { api } from 'constants/api';

import { ApiError, ApiResponse } from 'types/utils/api-response';
import { QueryOptions } from 'types/utils/query-options';

export type ScheduledCampaign = {
  audience_estimated: number;
  schedule_id: string;
  name: string;
  scheduled: string;
};

export type ScheduledCampaignsResponseType = ScheduledCampaign[];

export const useGetScheduledCampaigns = (
  options: QueryOptions<
    ScheduledCampaignsResponseType,
    AxiosError<ApiError>
  > = {}
) =>
  useQuery({
    queryFn: async (): Promise<ScheduledCampaignsResponseType> => {
      const { data } = await api.get<
        ApiResponse<ScheduledCampaignsResponseType>
      >(`/campaign/scheduled/list`);

      return data.data;
    },
    queryKey: ['campaigns', 'scheduled'],
    ...options,
  });
